import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { loadingManager, useIpinside, useMenuRouter } from 'scbk-services';
import { Dialog, useDelfino, usePageMove, usePopup } from 'scbk-shared-module';
import { useAstxIsInstall } from 'scbk-shared-module/modules/SecureKeypad';

export const useProgramInstall = () => {
  // 다국어 처리
  const { t } = useTranslation();

  const { isReady, installed, load } = useIpinside();
  const { astxIsInstall } = useAstxIsInstall();
  const { goMenu } = useMenuRouter();
  const { goMain } = usePageMove();
  const { delfinoG3Install } = useDelfino();
  const popup = usePopup('DelfinoG3Component');

  const check = useCallback(async (level: string): Promise<boolean | undefined> => {
    loadingManager.open();
    console.log(`installCheck start ${level}`);
    switch (level) {
      case '0': {
        //ASIS : securityLevel(0)
        //TODO: 뭐하는 레벨인지 모르겠어용.
        break;
      }
      case '1': {
        //ASIS : securityLevel(2)
        //Astx 를 그냥 설치 체크만
        await astxIsInstall();
        break;
      }
      case '2': {
        //ASIS : securityLevel(4)
        //로그인 전용
        // IPInside & ASTX 설치체크
        if ((await load()) && (await astxIsInstall())) {
          loadingManager.close();
          return true;
        }

        loadingManager.close();
        await Dialog.alert({
          content: t(
            'ProgramInstall.001',
            "거래를 진행하기 위해서는 보안프로그램 설치가 필요합니다.<br/>보안프로그램을 설치하시겠습니까?<br/>('확인'을 누르시면 설치페이지로 이동합니다.)",
          ),
          onClick: () => {
            goMenu('COMETC000'); // 통합설치
          },
        });
        return false;
      }
      case '3': {
        //ASIS : securityLevel(5)
        // IPinside -> Astx 그냥 설치 체크만
        const isIpinsideInstalled = await load();

        if (isIpinsideInstalled) {
          await astxIsInstall();
        }
        break;
      }
      case '4': {
        //ASIS : securityLevel(6)
        // IPinside -> Astx 순처로 체크하고 설치여부 Confirm
        const isIpinsideInstalled = await load();

        const alertMsg = t(
          'ProgramInstall.001',
          "거래를 진행하기 위해서는 보안프로그램 설치가 필요합니다.<br/>보안프로그램을 설치하시겠습니까?<br/>('확인'을 누르시면 설치페이지로 이동합니다.)",
        );

        if (!isIpinsideInstalled) {
          loadingManager.close();
          await Dialog.confirm({
            content: alertMsg,
            onClick: () => {
              //통합설치화면으로 가자.
              goMenu('COMETC000');
            },
            onCancel: () => {
              goMain();
            },
          });
          return false;
        }

        const isAstxInstalled = await astxIsInstall();

        const isAstx = isAstxInstalled === '' ? false : isAstxInstalled;

        if (!isAstx) {
          loadingManager.close();
          await Dialog.confirm({
            content: alertMsg,
            onClick: () => {
              //통합설치화면으로 가자.
              goMenu('COMETC000');
            },
            onCancel: () => {
              goMain();
            },
          });
          return false;
        }

        loadingManager.close();
        return true;
      }
      case '5': {
        // IPinside -> Astx -> Delfino G3 순차로 체크
        const isIpinsideInstalled = await load();
        if (!isIpinsideInstalled) {
          popup.setTrigger();
          popup.open();
          loadingManager.close();
          return;
        }

        const isAstxInstalled = await astxIsInstall();
        const isAstx = isAstxInstalled === '' ? false : isAstxInstalled;
        if (!isAstx) {
          popup.setTrigger();
          popup.open();
          loadingManager.close();
          return;
        }

        const isDelfinoG3Installed = await delfinoG3Install();
        if (!isDelfinoG3Installed) {
          popup.setTrigger();
          popup.open();
          loadingManager.close();
          return;
        }

        break;
      }
      default:
        break;
    }

    loadingManager.close();
    return;
  }, []);

  return {
    isIpinsideReady: isReady,
    ipinsideIsInstall: installed,
    astxIsInstall,
    delfinoG3Install,
    check,
    popup: { ...popup },
  };
};
